import { Dispatch } from 'redux';
import { TASK_ACTIONS, callWithLoader, handleError } from './actions';
import { api } from '../../service/api';
import {
  showErrorNotification,
  showSuccessNotification,
} from './notificationHelper';

export const getAllTasks = () => (dispatch: Dispatch) => {
  callWithLoader(
    api.getTasks().then((res) => {
      dispatch({
        type: TASK_ACTIONS.GET_TASKS,
        payload: res.data,
      });
    }),
    dispatch
  ).catch((err) => {
    handleError(dispatch, err);
  });
};

export const getTaskById = (id: string) => (dispatch: Dispatch) => {
  callWithLoader(
    api.getTaskById(id).then((res) => {
      dispatch({
        type: TASK_ACTIONS.GET_TASKS_BY_ID,
        payload: res.data,
      });
    }),
    dispatch
  ).catch((err) => {
    handleError(dispatch, err);
  });
};

export const getScheduledTasksByParentId =
  (parentId: string) => (dispatch: Dispatch) => {
    callWithLoader(
      api.getScheduledTasksByTaskId(parentId).then((res) => {
        dispatch({
          type: TASK_ACTIONS.GET_SCHEDULED_TASK,
          payload: { data: res.data, parentId },
        });
      }),
      dispatch
    ).catch((err) => {
      handleError(dispatch, err);
    });
  };
export const getScheduledTaskById = (id: string) => (dispatch: Dispatch) => {
  callWithLoader(
    api.getScheduledTaskById(id).then((res) => {
      dispatch({
        type: TASK_ACTIONS.GET_SCHEDULED_TASK,
        payload: { data: [res.data], id },
      });
    }),
    dispatch
  ).catch((err) => {
    handleError(dispatch, err);
  });
};
export const updateTask = (task: any) => (dispatch: Dispatch) => {
  callWithLoader(
    api.updateTask(task).then((res) => {
      dispatch({
        type: TASK_ACTIONS.UPDATE_TASK,
        payload: res.data,
      });
      showSuccessNotification(`Task ${task.TaskName} updated`, dispatch);
    }),
    dispatch
  ).catch((err) => {
    handleError(dispatch, err);
    showErrorNotification(
      `Task ${task.TaskName} failed to update.
  Error: ${err.message}
  `,
      dispatch
    );
  });
};
export const updateScheduledTask = (task: any) => (dispatch: Dispatch) => {
  callWithLoader(
    api.updateScheduledTask(task).then((res) => {
      dispatch({
        type: TASK_ACTIONS.UPDATE_SCHEDULED_TASK,
        payload: res.data,
      });
      showSuccessNotification(`Task ${task.id} updated`, dispatch);
    }),
    dispatch
  ).catch((err) => {
    handleError(dispatch, err);
    showErrorNotification(
      `Task ${task.id} failed to update.
  Error: ${err.message}
  `,
      dispatch
    );
  });
};

export const runTask = (id: string, params?: any) => (dispatch: Dispatch) => {
  api
    .runScheduledTask(id, params)
    .then((res) => {
      dispatch({
        type: TASK_ACTIONS.RUN_SCHEDULED_TASK,
        payload: res.data,
      });
      console.log(res.data);
      showSuccessNotification(
        `Task initiated ${JSON.stringify(res.data)} `,
        dispatch
      );
    })
    .catch((err) => {
      handleError(dispatch, err);
      showErrorNotification(
        `Failed to initiate Task 
    Error: ${err.message}`,
        dispatch
      );
    });
};

export const createScheduledTask =
  (data: {
    ClientId: string;
    TaskId: string;
    Schedule: string;
    TimeZone: string;
  }) =>
  (dispatch: Dispatch) => {
    callWithLoader(
      api.createScheduledTask(data).then((res) => {
        dispatch({
          type: TASK_ACTIONS.CREATE_SCHEDULED_TASK,
          payload: res.data,
        });
        showSuccessNotification(
          `Scheduled task created with id ${res.data.id}`,
          dispatch
        );
      }),
      dispatch
    ).catch((err) => {
      handleError(dispatch, err);
      showErrorNotification(
        `Failed to create scheduled task for Client: ${data.ClientId} and task id :${data.TaskId}.
      Error: ${err.message}`,
        dispatch
      );
    });
  };
export const setCreateScheduledTaskData =
  (data: any) => (dispatch: Dispatch) => {
    dispatch({
      type: TASK_ACTIONS.CREATE_SCHEDULED_TASK_DATA,
      payload: data,
    });
  };
export const setupScheduledTasks =
  (clientId: string) => (dispatch: Dispatch) => {
    callWithLoader(
      api.setupScheduledTasks(clientId).then((res) => {
        dispatch({
          type: TASK_ACTIONS.SCHEDULED_TASKS_BY_CLIENT_ID,
          payload: {
            clientId: clientId,
            tasks: res.data,
          },
        });
        showSuccessNotification(
          `Tasks scheduled for Client ID: ${clientId}`,
          dispatch
        );
      }),
      dispatch
    ).catch((err) => {
      handleError(dispatch, err);
      showErrorNotification(
        `Failed to schedule tasks for Client ID: ${clientId}
      Error: ${err.message}`,
        dispatch
      );
    });
  };
export const getScheduledTasksByClientId =
  (clientId: string) => (dispatch: Dispatch) => {
    callWithLoader(
      api.getScheduledTaskByClientId(clientId).then((res) => {
        dispatch({
          type: TASK_ACTIONS.SCHEDULED_TASKS_BY_CLIENT_ID,
          payload: { tasks: res.data, clientId },
        });
      }),
      dispatch
    ).catch((err) => {
      handleError(dispatch, err);
    });
  };
// export const getTasks = () => (dispatch) => {};
// export const getTasks = () => (dispatch) => {};
// export const getTasks = () => (dispatch) => {};
